import { MessageEmitter } from '@phaser/events';
import { Game } from '@phaser/scenes/Game';

export class AbilitySystem {
  public get needsAbilityTarget() {
    return this._abilityId;
  }

  private _scene = Game.current;
  private _abilityId: number;

  constructor() {
    this._registerEvents();
  }

  public onClick(x: number, y: number) {
    const playerId = this._scene.partySystem.getPlayerFromPos(x, y);

    const gridPos = this._scene.getGridPos(x, y);
    const cardId = this._scene.cards.find(c => c.pos === gridPos)?.id;
    if (!cardId && !playerId) return;

    if (this._abilityId) {
      const id = playerId || cardId || '';
      MessageEmitter.emit('onAbilityTarget', this._abilityId, id);
    }

    this._cleanup();
  }

  public destroy() {
    MessageEmitter.removeAllListeners('needAbilityTarget');
    MessageEmitter.removeAllListeners('clearAbilityTarget');
  }

  private _registerEvents() {
    MessageEmitter.on('needAbilityTarget', this._onNeedAbilityTarget);
    MessageEmitter.on('clearAbilityTarget', this._cleanup);
  }

  private _onNeedAbilityTarget = (abilityId: number) => {
    if (this._abilityId === abilityId) {
      return this._cleanup();
    }
    this._abilityId = abilityId;
  };

  private _cleanup() {
    this._abilityId = 0;
  }
}